import i18n from "@/plugins/i18n_single_language_file";

export const globalFunc = {
  slugify: (text, ampersand = "and") => {
    const a = "àáäâèéëêìíïîòóöôùúüûñçßÿỳýœæŕśńṕẃǵǹḿǘẍźḧğşı";
    const b = "aaaaeeeeiiiioooouuuuncsyyyoarsnpwgnmuxzhgsi";
    const p = new RegExp(a.split("").join("|"), "g");

    return text
      .toString()
      .toLowerCase()
      .replace(/[\s_]+/g, "-") // Replace whitespace and underscore with single hyphen
      .replace(p, (c) => b.charAt(a.indexOf(c))) // Replace special chars
      .replace(/&/g, `-${ampersand}-`) // Replace ampersand with custom word
      .replace(/[^\w-]+/g, "") // Remove all non-word chars
      .replace(/--+/g, "-") // Replace multiple hyphens with single
      .replace(/^-+|-+$/g, ""); // Remove leading and trailing hyphens
  },

  isURL: (str) => {
    return /^(?:\w+:)?\/\/([^\s.]+\.\S{2}|localhost[:?\d]*)\S*$/.test(str);
  },

  getValidImageUrl: (url) => {
    return globalFunc.isURL(url) ? url : process.env.VUE_APP_ORIGIN_CDN + url;
  },

  getBrowserLocale: () => {
    // Try to get from i18n first
    try {
      const i18nLang = i18n.locale;
      if (i18nLang) {
        // Map i18n locale codes to full locale strings
        const localeMap = {
          tr: "tr-TR",
          de: "de-DE",
          en: "en-US",
        };
        return localeMap[i18nLang] || i18nLang;
      }
    } catch (e) {
      // i18n not available
    }

    // Fallback to browser language
    const browserLang =
      navigator.language || navigator.userLanguage || navigator.languages?.[0];
    return browserLang || "de-DE";
  },

  formatDate: (dateString) => {
    if (!dateString) return "";
    const date = new Date(dateString);
    const locale = globalFunc.getBrowserLocale();
    return date.toLocaleString(locale);
  },

  convertQuantityUnit: (qty, fromUnit, toUnit, unitLabel) => {
    if (!fromUnit || !toUnit || !qty || fromUnit === toUnit) return null;

    const conversions = {
      'GRM_KGM': 0.001,
      'KGM_GRM': 1000,
      'MLT_LTR': 0.001,
      'LTR_MLT': 1000,
    };

    const factor = conversions[`${fromUnit}_${toUnit}`];
    if (!factor) return null;

    const converted = qty * factor;
    const locale = globalFunc.getBrowserLocale();
    const label = unitLabel || toUnit;
    return `\u2248 ${converted.toLocaleString(locale, { maximumFractionDigits: 2 })} ${label}`;
  },

  formatDateShort: (dateString) => {
    if (!dateString) return "";
    const date = new Date(dateString);
    const now = new Date();
    const diffTime = Math.abs(now - date);
    const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24));
    const locale = globalFunc.getBrowserLocale();

    if (diffDays === 0) {
      // Today - show only time
      return date.toLocaleTimeString(locale, {
        hour: "2-digit",
        minute: "2-digit",
      });
    } else if (diffDays === 1) {
      // Yesterday
      const yesterdayTranslations = {
        tr: "Dün",
        de: "Gestern",
        en: "Yesterday",
      };
      const lang = locale.split("-")[0];
      return yesterdayTranslations[lang] || "Yesterday";
    } else if (diffDays < 7) {
      // Within a week - show day and month
      return date.toLocaleDateString(locale, {
        day: "numeric",
        month: "short",
      });
    } else {
      // Older - show day, month and year
      return date.toLocaleDateString(locale, {
        day: "numeric",
        month: "short",
        year: "2-digit",
      });
    }
  },

  formatDateRelative: (dateString) => {
    if (!dateString) return "";
    const date = new Date(dateString);
    if (Number.isNaN(date.getTime())) return "";

    const now = new Date();
    const dateDay = Date.UTC(date.getFullYear(), date.getMonth(), date.getDate());
    const today = Date.UTC(now.getFullYear(), now.getMonth(), now.getDate());
    const dayDifference = Math.round((dateDay - today) / 86400000);
    const absoluteDays = Math.abs(dayDifference);
    let value = dayDifference;
    let unit = "day";

    if (absoluteDays >= 365) {
      value = Math.trunc(dayDifference / 365);
      unit = "year";
    } else if (absoluteDays >= 30) {
      value = Math.trunc(dayDifference / 30);
      unit = "month";
    } else if (absoluteDays >= 7) {
      value = Math.trunc(dayDifference / 7);
      unit = "week";
    }

    const locale = globalFunc.getBrowserLocale();
    if (typeof Intl.RelativeTimeFormat === "function") {
      return new Intl.RelativeTimeFormat(locale, { numeric: "auto" }).format(value, unit);
    }

    const relativeTimeKey = "global.relative_time";
    if (unit === "day" && value === 0) {
      return i18n.t(`${relativeTimeKey}.today`);
    }
    if (unit === "day" && value === -1) {
      return i18n.t(`${relativeTimeKey}.yesterday`);
    }
    if (unit === "day" && value === 1) {
      return i18n.t(`${relativeTimeKey}.tomorrow`);
    }

    const magnitude = Math.abs(value);
    const unitLabel = i18n.tc(`${relativeTimeKey}.units.${unit}`, magnitude, { count: magnitude });
    const relativeTemplate = value < 0 ? `${relativeTimeKey}.past` : `${relativeTimeKey}.future`;
    return i18n.t(relativeTemplate, { count: magnitude, unit: unitLabel });
  },
};

export const globalVar = {
  // stockUnits: [
  //   { value: 'piece', label: i18n.t('global.piece') },
  // ],
  currency: [
    { value: "EUR", label: "EUR" },
    { value: "TRY", label: "TRY" },
    { value: "USD", label: "USD" },
  ],
  tax: [
    { value: null, label: "---" },
    { value: "0.07", label: "% 7" },
    { value: "0.08", label: "% 8" },
    { value: "0.09", label: "% 9" },
    { value: "0.17", label: "% 17" },
    { value: "0.18", label: "% 18" },
    { value: "0.19", label: "% 19" },
  ],
  packagingTypes: [
    { value: "CR", label: i18n.t("packaging.type_codes.CR") },
    { value: "CS", label: i18n.t("packaging.type_codes.CS") },
    { value: "BX", label: i18n.t("packaging.type_codes.BX") },
    { value: "PK", label: i18n.t("packaging.type_codes.PK") },
    { value: "BG", label: i18n.t("packaging.type_codes.BG") },
    { value: "BT", label: i18n.t("packaging.type_codes.BT") },
    { value: "CN", label: i18n.t("packaging.type_codes.CN") },
    { value: "CT", label: i18n.t("packaging.type_codes.CT") },
    { value: "TB", label: i18n.t("packaging.type_codes.TB") },
    { value: "JR", label: i18n.t("packaging.type_codes.JR") },
    { value: "SA", label: i18n.t("packaging.type_codes.SA") },
    { value: "RO", label: i18n.t("packaging.type_codes.RO") },
    { value: "PL", label: i18n.t("packaging.type_codes.PL") },
    { value: "DR", label: i18n.t("packaging.type_codes.DR") },
  ],
  orderDepartmentOptions: [
    { value: 1, label: i18n.t("department.order.food"), icon: "cil-burger" },
    {
      value: 2,
      label: i18n.t("department.order.beverage"),
      icon: "cil-coffee",
    },
    { value: 3, label: i18n.t("department.order.service"), icon: "cil-puzzle" },
  ],
};
